import React, { Component } from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';

import GeneralLogs from './general_logs';
import UserLogs from './user_logs';
import EngineLogs from './engine_logs';
import CronLogs from './cron_logs';

class LogsSetting extends Component {
  render() {
    return (
        <Switch>
        <Route path="/settings/logs/general" component={GeneralLogs}/>
        <Route path="/settings/logs/engine" component={EngineLogs}/>
        <Route path="/settings/logs/cron" component={CronLogs}/>
        <Route path="/settings/logs/users" component={UserLogs}/>
        
        <Redirect from="*" to= "/settings/logs/general"/>
    </Switch>
    );
  }
}

export default LogsSetting;
